module.exports = __webpack_public_path__ + "img/tgg-1.e02c93b4.webp";